import React from 'react';
import {
    SwipeableListItem as NewSwipeableListItem,
    LeadingActions,
    TrailingActions,
    SwipeAction,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import './swipeable-overrides.css';
import { SWIPE_START_THRESHOLD, SCROLL_START_THRESHOLD } from './constants';

// Drop-in replacement for the old @sandstreamdev/react-swipeable-list
// SwipeableListItem. Maps the legacy { content, action, actionAnimation }
// shape on swipeLeft/swipeRight props into the new
// LeadingActions/TrailingActions/SwipeAction subtree, so existing call
// sites can switch by changing only their import path.
//
// Direction mapping (matches sandstreamdev semantics — gesture-based,
// independent of LTR/RTL):
//   swipeLeft  → trailingActions (revealed by dragging finger left)
//   swipeRight → leadingActions  (revealed by dragging finger right)
const renderSwipeAction = (config, kind) => {
    if (!config) return undefined;
    const { content, action, actionAnimation } = config;
    const Wrapper = kind === 'leading' ? LeadingActions : TrailingActions;
    return (
        <Wrapper>
            <SwipeAction
                onClick={action}
                destructive={actionAnimation === 'REMOVE'}
                Tag="div"
            >
                {content}
            </SwipeAction>
        </Wrapper>
    );
};

/**
 * @param {any} props
 */
export const SwipeableListItem = (props) => {
    const { swipeLeft, swipeRight, children, ...rest } = props;
    return (
        <NewSwipeableListItem
            swipeStartThreshold={SWIPE_START_THRESHOLD}
            scrollStartThreshold={SCROLL_START_THRESHOLD}
            {...rest}
            trailingActions={renderSwipeAction(swipeLeft, 'trailing')}
            leadingActions={renderSwipeAction(swipeRight, 'leading')}
        >
            {children}
        </NewSwipeableListItem>
    );
};

// Compat shim for the few sites importing ActionAnimations (used as the
// `actionAnimation` value to opt into the destructive remove animation).
export const ActionAnimations = Object.freeze({
    REMOVE: 'REMOVE',
    RETURN: 'RETURN',
    NONE: 'NONE',
});
